export default class VisualizationService {
  static serviceName = 'VisualizationService';

  setComponent(component) {}

  getComponent() {}

  update(configuration) {}

  registerUpdateFunction(onUpdateFn) {}

  registerScreenshotsGetter(getScreenshotsFn) {}

  getScreenshots() {}

  updateDesignAreaList() {}

  isReadyToRender() {
    return true;
  }

  isReadyToRenderCustomDesign() {
    return false;
  }

  registerComponentChangeListener() {}

  initDesignAreaInteraction() {}

  update2DMaxZoom() {}

  getActiveDesignArea() {}

  enableUserMovement() {}

  freeUserMovement() {}

  abortScreenshotting() {}
}
